import { useTranslation } from 'react-i18next';
import './NeedPay.css';

const NeedPay = () => {
    const { t } = useTranslation('Tariff');

    return (
        <div className="need-pay">
            <div className="need-pay__icon">
                <i className="bi bi-credit-card" aria-hidden="true" />
            </div>
            <p className="need-pay__lead">{t('needPayText')}</p>
            <p className="need-pay__hint">{t('needPayHint')}</p>
        </div>
    );
};

export default NeedPay;
